import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemePreference = 'light' | 'dark' | 'system';

export interface ThemeState {
  preference: ThemePreference;
}

const initialState: ThemeState = {
  preference: 'system',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemePreference(state, action: PayloadAction<ThemePreference>) {
      state.preference = action.payload;
    },
    toggleTheme(state, action: PayloadAction<'light' | 'dark'>) {
      state.preference = action.payload === 'dark' ? 'light' : 'dark';
    },
  },
});

export const { setThemePreference, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
